import React from 'react';
import { useDropzone } from 'react-dropzone';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { ReactComponent as DeleteIcon } from '../../assets/delete.svg';
import { ReactComponent as DropIcon } from '../../assets/drop.svg';
import { ReactComponent as DottedCircleIcon } from '../../assets/circle-dash.svg';
import './styles.scss';

import { useStore } from '../../store';

const UserAvatar = observer(({ src, toggleAvatar }) => {
  const {
    rootStore: { profileStore },
  } = useStore();

  const { t } = useTranslation();

  const onDrop = dropped => {
    toggleAvatar(dropped[0]);
  };

  const { getRootProps, getInputProps, isDragActive, open: openDropzone } = useDropzone({
    onDrop,
    accept: 'image/*',
    noClick: true,
  });

  const clearAvatar = event => {
    event.stopPropagation();
    if (src && (src.startsWith('https://cdn.auth0.com') || src.startsWith('https://s.gravatar.com'))) {
      openDropzone();
    } else {
      profileStore.removeAvatarImage(t);
    }
  };

  let showAdd = false;
  if (src && (src.startsWith('https://cdn.auth0.com') || src.startsWith('https://s.gravatar.com'))) {
    showAdd = true;
  }

  return (
    <div>
      <div className="upload-avatar-container" {...getRootProps()}>
        <img src={`${src}`} alt="Avatar" className={`avatar-images ${isDragActive ? 'drag-active' : ''}`} />
        {!isDragActive ? (
          <div onClick={clearAvatar} className="btn avatar-button">
            {showAdd ? <span>+</span> : <DeleteIcon />}
          </div>
        ) : (
          <div className="avatar-image-overlay">
            <DropIcon className="drop-icon" />
            <DottedCircleIcon />
          </div>
        )}
        <input {...getInputProps()} />
      </div>
    </div>
  );
});

export default UserAvatar;
